import React from 'react';
import { IconProps } from './IconTypes';

const XAILogo: React.FC<IconProps> = ({
  size = 16,
  color = "currentColor",
  className = "",
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      fill={color}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M14,12 L34,12 L86,88 L66,88 Z" />
      <path d="M66,12 L86,12 L62,46 L52,32 Z" />
      <path d="M14,88 L38,54 L48,68 L34,88 Z" />
    </svg>
  );
};

export default XAILogo;
